export default {
  functionKey: "ARRONDI. SUP",
  title: "ARRONDI. SUP",
  group: "Calcul",
  origin: [],
  target: [],
  description: "Arrondi un nombre à l'entier supérieur",
  isStarred: false,

  generate(destination, origin, args, isArgumentCol) {
    const jsCode = `${destination} = Math.ceil(${origin});`;
    const safeCode = `
      if (!isNaN(parseInt(${origin}))) {
        ${jsCode}
      } else {
        ${destination} = '';
      }`;
    return { displayCode: jsCode, safeCode };
  }
}
